/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.property.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.property = {};
proto.witbooking.backoffice.property.v1 = require('./property_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.property.v1.PropertyAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.property.v1.PropertyAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest,
 *   !proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse>}
 */
const methodDescriptor_PropertyAPI_GetPropertyTickers = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyTickers',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest,
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest,
 *   !proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse>}
 */
const methodInfo_PropertyAPI_GetPropertyTickers = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.property.v1.PropertyAPIClient.prototype.getPropertyTickers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyTickers',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_GetPropertyTickers,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.property.v1.PropertyAPIPromiseClient.prototype.getPropertyTickers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyTickers',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_GetPropertyTickers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest,
 *   !proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse>}
 */
const methodDescriptor_PropertyAPI_GetPropertyTickersWithoutAgr = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyTickersWithoutAgr',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest,
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest,
 *   !proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse>}
 */
const methodInfo_PropertyAPI_GetPropertyTickersWithoutAgr = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.property.v1.PropertyAPIClient.prototype.getPropertyTickersWithoutAgr =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyTickersWithoutAgr',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_GetPropertyTickersWithoutAgr,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.property.v1.PropertyAPIPromiseClient.prototype.getPropertyTickersWithoutAgr =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyTickersWithoutAgr',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_GetPropertyTickersWithoutAgr);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest,
 *   !proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse>}
 */
const methodDescriptor_PropertyAPI_GetAdminPropertyTickers = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.property.v1.PropertyAPI/GetAdminPropertyTickers',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest,
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest,
 *   !proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse>}
 */
const methodInfo_PropertyAPI_GetAdminPropertyTickers = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.property.v1.PropertyAPIClient.prototype.getAdminPropertyTickers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/GetAdminPropertyTickers',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_GetAdminPropertyTickers,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.property.v1.PropertyAPIPromiseClient.prototype.getAdminPropertyTickers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/GetAdminPropertyTickers',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_GetAdminPropertyTickers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest,
 *   !proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse>}
 */
const methodDescriptor_PropertyAPI_GetPropertyTickersWithActiveQuotation = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyTickersWithActiveQuotation',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest,
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest,
 *   !proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse>}
 */
const methodInfo_PropertyAPI_GetPropertyTickersWithActiveQuotation = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.property.v1.PropertyAPIClient.prototype.getPropertyTickersWithActiveQuotation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyTickersWithActiveQuotation',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_GetPropertyTickersWithActiveQuotation,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.property.v1.PropertyAPIPromiseClient.prototype.getPropertyTickersWithActiveQuotation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyTickersWithActiveQuotation',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_GetPropertyTickersWithActiveQuotation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest,
 *   !proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse>}
 */
const methodDescriptor_PropertyAPI_GetPropertyConfiguration = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyConfiguration',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest,
  proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest,
 *   !proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse>}
 */
const methodInfo_PropertyAPI_GetPropertyConfiguration = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.property.v1.PropertyAPIClient.prototype.getPropertyConfiguration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyConfiguration',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_GetPropertyConfiguration,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.property.v1.PropertyAPIPromiseClient.prototype.getPropertyConfiguration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyConfiguration',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_GetPropertyConfiguration);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest,
 *   !proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse>}
 */
const methodDescriptor_PropertyAPI_GetPropertyInfo = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyInfo',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest,
  proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest,
 *   !proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse>}
 */
const methodInfo_PropertyAPI_GetPropertyInfo = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.property.v1.PropertyAPIClient.prototype.getPropertyInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyInfo',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_GetPropertyInfo,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.property.v1.PropertyAPIPromiseClient.prototype.getPropertyInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyInfo',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_GetPropertyInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest,
 *   !proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse>}
 */
const methodDescriptor_PropertyAPI_GetPropertyChildren = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyChildren',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest,
  proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest,
 *   !proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse>}
 */
const methodInfo_PropertyAPI_GetPropertyChildren = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.property.v1.PropertyAPIClient.prototype.getPropertyChildren =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyChildren',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_GetPropertyChildren,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.property.v1.PropertyAPIPromiseClient.prototype.getPropertyChildren =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/GetPropertyChildren',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_GetPropertyChildren);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.property.v1.GetParentTickerRequest,
 *   !proto.witbooking.backoffice.property.v1.GetParentTickerResponse>}
 */
const methodDescriptor_PropertyAPI_GetParentTicker = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.property.v1.PropertyAPI/GetParentTicker',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.property.v1.GetParentTickerRequest,
  proto.witbooking.backoffice.property.v1.GetParentTickerResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.GetParentTickerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.GetParentTickerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.property.v1.GetParentTickerRequest,
 *   !proto.witbooking.backoffice.property.v1.GetParentTickerResponse>}
 */
const methodInfo_PropertyAPI_GetParentTicker = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.property.v1.GetParentTickerResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.GetParentTickerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.GetParentTickerResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.property.v1.GetParentTickerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.property.v1.GetParentTickerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.property.v1.GetParentTickerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.property.v1.PropertyAPIClient.prototype.getParentTicker =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/GetParentTicker',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_GetParentTicker,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.property.v1.GetParentTickerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.property.v1.GetParentTickerResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.property.v1.PropertyAPIPromiseClient.prototype.getParentTicker =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/GetParentTicker',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_GetParentTicker);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest,
 *   !proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse>}
 */
const methodDescriptor_PropertyAPI_CreatePropertyChain = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.property.v1.PropertyAPI/CreatePropertyChain',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest,
  proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest,
 *   !proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse>}
 */
const methodInfo_PropertyAPI_CreatePropertyChain = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse,
  /**
   * @param {!proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.property.v1.PropertyAPIClient.prototype.createPropertyChain =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/CreatePropertyChain',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_CreatePropertyChain,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.property.v1.PropertyAPIPromiseClient.prototype.createPropertyChain =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.property.v1.PropertyAPI/CreatePropertyChain',
      request,
      metadata || {},
      methodDescriptor_PropertyAPI_CreatePropertyChain);
};


module.exports = proto.witbooking.backoffice.property.v1;

